/**
 * Helpers para enviar eventos estándar del Meta Pixel.
 * Seguros de llamar aunque el pixel no haya cargado o el usuario haya revocado
 * el consentimiento (en ese caso fbq no envía nada).
 */

type FbqParams = Record<string, string | number | boolean | undefined>

export function trackMetaEvent(event: string, params?: FbqParams) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  try {
    window.fbq('track', event, params)
  } catch {
    // no-op: nunca romper la UI por analítica
  }
}

/** Contacto directo: WhatsApp, teléfono o correo */
export function trackContact(method: 'whatsapp' | 'phone' | 'email', extra?: FbqParams) {
  trackMetaEvent('Contact', {
    content_name: method,
    content_category: typeof window !== 'undefined' ? window.location.pathname : undefined,
    ...extra,
  })
}

/** Lead completado (formulario enviado) */
export function trackLead(extra?: FbqParams) {
  trackMetaEvent('Lead', {
    content_category: typeof window !== 'undefined' ? window.location.pathname : undefined,
    ...extra,
  })
}

/** Clasifica un href como canal de contacto, o null si no lo es */
export function getContactMethod(href: string): 'whatsapp' | 'phone' | 'email' | null {
  const h = href.toLowerCase()
  if (h.includes('wa.me/') || h.includes('api.whatsapp.com') || h.includes('web.whatsapp.com') || h.startsWith('whatsapp:')) return 'whatsapp'
  if (h.startsWith('tel:')) return 'phone'
  if (h.startsWith('mailto:')) return 'email'
  return null
}
